<template>
  <div :class="`resume-row ${classes}`">
    <span class="resume-row--start">
      <vb-icon v-if="icon" :name="icon" :size="18"></vb-icon>
      <span>{{ label }}</span>
      <vb-icon
        v-if="info"
        name="info"
        :id="`resume-row:${label}`"
        :ref="`resume-row:${label}`"
        :size="16"
        :color="'#AAA'"
        style="margin-top: -2px"
      />
      <b-popover
        v-if="info"
        :target="`resume-row:${label}`"
        triggers="hover"
        placement="top"
      >
        <span v-html="info"></span>
      </b-popover>
    </span>
    <span>
      <slot name="content"></slot>
      <span v-if="!$slots.content">
        {{ parsed_content }}
      </span>
    </span>
  </div>
</template>

<script>
import { currency_decimals } from "@resources";

export default {
  name: "sidebar-row",
  props: {
    label: String,
    content: Number,
    icon: {
      type: String,
      default: () => "",
    },
    // Pre-resolved glyph (€, $, …) from flight_offer.price.currencySymbol.
    currency_symbol: {
      type: String,
      default: () => "",
    },
    // ISO 4217 code; drives decimal precision (JPY → 0, KWD → 3, default 2).
    currency: {
      type: String,
      default: () => "",
    },
    classes: {
      type: String,
      default: () => "",
    },
    info: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    parsed_content() {
      if (this.$slots.content) {
        return "";
      }
      if (this.currency_symbol) {
        const amount = Number(this.content);
        const formatted = Number.isFinite(amount)
          ? amount.toFixed(currency_decimals(this.currency))
          : this.content;
        return `${this.currency_symbol} ${formatted}`;
      }
      return this.content;
    },
  },
};
</script>

<style lang="scss" scoped>
.resume-row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &--start {
    display: flex;
    gap: 5px;
    align-items: center;
  }
}
</style>
